import { forwardRef } from 'react'
import { useMediaQuery, Box, BoxProps, Theme } from '@mui/material'

export const Content = forwardRef<typeof Box, BoxProps>(({ children, sx, ...rest }, ref) => {
  const isLarge = useMediaQuery<Theme>((theme) => theme.breakpoints.up('sm'))

  return (
    <Box
      ref={ref}
      sx={{
        px: isLarge ? 9 : 3,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  )
})
